module.exports = __webpack_public_path__ + "img/39_fineStaff_zw.146ae564.png";